import { preloadImage } from '@mail/3promo';
import darkCover from 'img/unlimited-docs/modal/dark/in_progress.png';
import lightCover from 'img/unlimited-docs/modal/light/in_progress.png';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import type { UnlimitedDocumentsThanksModalProps } from './UnlimitedDocumentsThanksModal';

const IMAGE_PRELOAD_TIMEOUT = 3 * 1000;

export const renderUnlimitedDocumentsThanksModal = (data: UnlimitedDocumentsThanksModalProps) => {
    openPopupHelper({
        popupName: popupNames.UNLIMITED_DOCUMENTS_THANKS_MODAL,
        data,
        onClose: data.onClose,
    });
};

export const closeUnlimitedDocumentsThanksModal = () => closePopupHelper(popupNames.UNLIMITED_DOCUMENTS_THANKS_MODAL);

export const getUnlimitedDocumentsThanksModalCoverImageUrl = (isDarkTheme: boolean) => {
    return isDarkTheme ? darkCover : lightCover;
};

export const preloadUnlimitedDocumentsThanksModalCover = async () => {
    const coverImageUrl = getUnlimitedDocumentsThanksModalCoverImageUrl(isDarkThemeModeEnabled());
    await preloadImage({ src: coverImageUrl, timeout: IMAGE_PRELOAD_TIMEOUT });
};
